import React from 'react';
import { Link } from 'react-router-dom';

export default function KitTile({ to, title, subtitle, preview, accent = 'cyan', className = '' }) {
  const borderVar =
    accent === 'gold'
      ? 'var(--accent-gold)'
      : accent === 'pink'
        ? 'var(--accent-pink)'
        : accent === 'purple'
          ? 'var(--accent-purple)'
          : 'var(--accent-cyan)';
  return (
    <Link to={to} className={['kit-tile', className].filter(Boolean).join(' ')} style={{ borderColor: borderVar }}>
      <div className="kit-tile-title">{title}</div>
      {subtitle && <div className="kit-tile-sub">{subtitle}</div>}
      {preview && <div className="kit-tile-preview">{preview}</div>}
    </Link>
  );
}
